export const spanishFlashcards = {
  categories: [
    {
      es: "Hola",
      rm: "O-la",
      en: "Hello",
    },
    {
      es: "Buenos días",
      rm: "Bweh-nos dee-as",
      en: "Good morning",
    },
    {
      es: "Buenas tardes",
      rm: "Bweh-nas tar-des",
      en: "Good afternoon / Good evening",
    },
    {
      es: "Buenas noches",
      rm: "Bweh-nas no-ches",
      en: "Good night / Good evening",
    },
    {
      es: "Adiós",
      rm: "A-dee-os",
      en: "Goodbye",
    },
    {
      es: "Hasta luego",
      rm: "As-ta loo-eh-go",
      en: "See you later",
    },
    {
      es: "Por favor",
      rm: "Por fa-vor",
      en: "Please",
    },
    {
      es: "Gracias",
      rm: "Gra-thee-as",
      en: "Thank you",
    },
    {
      es: "Muchas gracias",
      rm: "Moo-chas gra-thee-as",
      en: "Thank you very much",
    },
    {
      es: "De nada",
      rm: "De na-da",
      en: "You're welcome",
    },
    {
      es: "Perdón",
      rm: "Per-don",
      en: "Excuse me / Sorry",
    },
    {
      es: "Lo siento",
      rm: "Lo see-en-to",
      en: "I'm sorry",
    },
    {
      es: "Sí",
      rm: "See",
      en: "Yes",
    },
    {
      es: "No",
      rm: "No",
      en: "No",
    },
    {
      es: "Vale",
      rm: "Va-leh",
      en: "Okay / Alright (Spain)",
    },
    {
      es: "Está bien",
      rm: "Es-ta bee-en",
      en: "It's okay / Alright",
    },
    {
      es: "No entiendo",
      rm: "No en-tee-en-do",
      en: "I don't understand",
    },
    {
      es: "¿Habla inglés?",
      rm: "Ah-bla een-gles?",
      en: "Do you speak English?",
    },
    {
      es: "¿Cómo está?",
      rm: "Ko-mo es-ta?",
      en: "How are you? (formal)",
    },
    {
      es: "¿Cómo estás?",
      rm: "Ko-mo es-tas?",
      en: "How are you? (informal)",
    },
    {
      es: "¿Qué tal?",
      rm: "Keh tal?",
      en: "What's up? / How's it going?",
    },
    {
      es: "Bien, gracias",
      rm: "Bee-en, gra-thee-as",
      en: "Fine, thank you",
    },
    {
      es: "¿Cómo se llama?",
      rm: "Ko-mo se ya-ma?",
      en: "What's your name? (formal)",
    },
    {
      es: "¿Cómo te llamas?",
      rm: "Ko-mo te ya-mas?",
      en: "What's your name? (informal)",
    },
    {
      es: "Me llamo...",
      rm: "Me ya-mo...",
      en: "My name is...",
    },
    {
      es: "¿Dónde está...?",
      rm: "Don-de es-ta...?",
      en: "Where is...?",
    },
    {
      es: "¿Dónde están los baños?",
      rm: "Don-de es-tan los ba-nyos?",
      en: "Where are the bathrooms?",
    },
    {
      es: "¿Dónde está la estación de tren?",
      rm: "Don-de es-ta la es-ta-thee-on de tren?",
      en: "Where is the train station?",
    },
    {
      es: "¿Dónde está el aeropuerto?",
      rm: "Don-de es-ta el a-eh-ro-pwer-to?",
      en: "Where is the airport?",
    },
    {
      es: "¿Cuánto cuesta?",
      rm: "Kwan-to kwes-ta?",
      en: "How much does it cost?",
    },
    {
      es: "Es muy caro",
      rm: "Es muy ka-ro",
      en: "It's very expensive",
    },
    {
      es: "Ayuda!",
      rm: "A-yoo-da!",
      en: "Help!",
    },
    {
      es: "Socorro!",
      rm: "So-ko-rro!",
      en: "Help! (Emergency)",
    },
    {
      es: "Estoy perdido/a",
      rm: "Es-toy per-dee-do/da",
      en: "I am lost (male/female)",
    },
    {
      es: "Busco...",
      rm: "Boo-sko...",
      en: "I'm looking for...",
    },
    {
      es: "Quisiera...",
      rm: "Kee-see-eh-ra...",
      en: "I would like...",
    },
    {
      es: "Quiero...",
      rm: "Kee-eh-ro...",
      en: "I want...",
    },
    {
      es: "Un café, por favor",
      rm: "Un ka-feh, por fa-vor",
      en: "A coffee, please",
    },
    {
      es: "La cuenta, por favor",
      rm: "La kwen-ta, por fa-vor",
      en: "The bill, please",
    },
    {
      es: "Soy vegetariano/a",
      rm: "Soy veh-heh-ta-ree-a-no/na",
      en: "I am vegetarian (male/female)",
    },
    {
      es: "Soy alérgico/a a...",
      rm: "Soy a-ler-hee-ko/ka a...",
      en: "I am allergic to...",
    },
    {
      es: "Está delicioso",
      rm: "Es-ta de-lee-thee-o-so",
      en: "It's delicious",
    },
    {
      es: "Salud!",
      rm: "Sa-lud!",
      en: "Cheers!",
    },
    {
      es: "No me siento bien",
      rm: "No me see-en-to bee-en",
      en: "I don't feel well",
    },
    {
      es: "¿Dónde está el hospital?",
      rm: "Don-de es-ta el os-pee-tal?",
      en: "Where is the hospital?",
    },
    {
      es: "Hablo un poco de español",
      rm: "Ah-blo un po-ko de es-pa-nyol",
      en: "I speak a little Spanish",
    },
    {
      es: "Más despacio, por favor",
      rm: "Mas des-pa-thee-o, por fa-vor",
      en: "More slowly, please",
    },
    {
      es: "¿Puede repetir, por favor?",
      rm: "Pweh-de re-peh-teer, por fa-vor?",
      en: "Can you repeat that, please?",
    },
    {
      es: "Estoy cansado/a",
      rm: "Es-toy kan-sa-do/da",
      en: "I am tired (male/female)",
    },
    {
      es: "¿Qué tiempo hace?",
      rm: "Keh tee-em-po a-theh?",
      en: "What's the weather like?",
    },
    {
      es: "Hace buen tiempo",
      rm: "A-theh bwen tee-em-po",
      en: "The weather is nice",
    },
    {
      es: "Hace calor",
      rm: "A-theh ka-lor",
      en: "It's hot",
    },
    {
      es: "Hace frío",
      rm: "A-theh free-o",
      en: "It's cold",
    },
    {
      es: "Está lloviendo",
      rm: "Es-ta yo-vee-en-do",
      en: "It's raining",
    },
    {
      es: "De acuerdo",
      rm: "De a-kwer-do",
      en: "Okay / Agreed",
    },
    {
      es: "No estoy de acuerdo",
      rm: "No es-toy de a-kwer-do",
      en: "I disagree",
    },
    {
      es: "Es interesante",
      rm: "Es een-teh-re-san-teh",
      en: "It's interesting",
    },
    {
      es: "Es importante",
      rm: "Es eem-por-tan-teh",
      en: "It's important",
    },
    {
      es: "Es posible",
      rm: "Es po-see-bleh",
      en: "It's possible",
    },
    {
      es: "Es imposible",
      rm: "Es eem-po-see-bleh",
      en: "It's impossible",
    },
    {
      es: "¿Qué hora es?",
      rm: "Keh o-ra es?",
      en: "What time is it?",
    },
    {
      es: "Hoy",
      rm: "Oy",
      en: "Today",
    },
    {
      es: "Mañana",
      rm: "Ma-nya-na",
      en: "Tomorrow",
    },
    {
      es: "Ayer",
      rm: "A-yer",
      en: "Yesterday",
    },
    {
      es: "Ahora",
      rm: "A-o-ra",
      en: "Now",
    },
    {
      es: "Más tarde",
      rm: "Mas tar-deh",
      en: "Later",
    },
    {
      es: "A la derecha",
      rm: "A la de-reh-cha",
      en: "To the right",
    },
    {
      es: "A la izquierda",
      rm: "A la ees-kee-er-da",
      en: "To the left",
    },
    {
      es: "Todo recto",
      rm: "To-do rek-to",
      en: "Straight ahead",
    },
    {
      es: "Cerca",
      rm: "Ther-ka",
      en: "Near",
    },
    {
      es: "Lejos",
      rm: "Leh-hos",
      en: "Far",
    },
    {
      es: "Estoy perdido/a",
      rm: "Es-toy per-dee-do/da",
      en: "I'm lost (male/female)",
    },
    {
      es: "Estoy enfermo/a",
      rm: "Es-toy en-fer-mo/ma",
      en: "I am sick (male/female)",
    },
    {
      es: "Es urgente",
      rm: "Es oor-hen-teh",
      en: "It's urgent",
    },
    {
      es: "Un momento, por favor",
      rm: "Un mo-men-to, por fa-vor",
      en: "One moment, please",
    },
    {
      es: "No sé",
      rm: "No seh",
      en: "I don't know",
    },
    {
      es: "Está bien",
      rm: "Es-ta bee-en",
      en: "It's good / It's okay",
    },
    {
      es: "No pasa nada",
      rm: "No pa-sa na-da",
      en: "It's nothing / No problem",
    },
    {
      es: "No hay problema",
      rm: "No ay pro-ble-ma",
      en: "No problem",
    },
    {
      es: "Cuidado!",
      rm: "Kwee-da-do!",
      en: "Be careful!",
    },
    {
      es: "Déjame en paz",
      rm: "De-ha-me en pas",
      en: "Leave me alone",
    },
    {
      es: "Tengo hambre",
      rm: "Ten-go am-breh",
      en: "I'm hungry",
    },
    {
      es: "Tengo sed",
      rm: "Ten-go sed",
      en: "I'm thirsty",
    },
    {
      es: "Lo siento mucho",
      rm: "Lo see-en-to moo-cho",
      en: "I'm very sorry",
    },
    {
      es: "Felicidades!",
      rm: "Feh-lee-thee-da-des!",
      en: "Congratulations!",
    },
    {
      es: "Buena suerte!",
      rm: "Bweh-na swer-teh!",
      en: "Good luck!",
    },
    {
      es: "Buen viaje!",
      rm: "Bwen vee-ah-heh!",
      en: "Have a good trip!",
    },
    {
      es: "Salud!",
      rm: "Sa-lud!",
      en: "To your health! (Cheers)",
    },
    {
      es: "¿Es gratis?",
      rm: "Es gra-tees?",
      en: "Is it free?",
    },
    {
      es: "¿Cuál es la contraseña del wifi?",
      rm: "Kwal es la kon-tra-se-nya del wee-fee?",
      en: "What is the wifi password?",
    },
    {
      es: "¿Puedo tomar una foto?",
      rm: "Pweh-do to-mar oo-na fo-to?",
      en: "Can I take a picture?",
    },
  ],
};
